import { render, staticRenderFns } from "./CardsPage.vue?vue&type=template&id=9780c668&"
import script from "./CardsPage.vue?vue&type=script&lang=js&"
export * from "./CardsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports